module.exports = __webpack_public_path__ + "assets/images/EUR020.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR020.png
// module id = 1360
// module chunks = 1